import ResponseError from './ResponseError';

export default ResponseError;
